// --- START PATCH: AccountLayout with horizontal tabs and Outlet ---
import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/auth/useAuth";

function tabClasses(isActive: boolean) {
  return clsx(
    "inline-flex items-center rounded-full px-3.5 py-1.5 text-[15px] font-medium transition-colors",
    "hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
    isActive ? "bg-primary text-primary-foreground" : "bg-transparent"
  );
}

export default function AccountLayout() {
  const { t } = useTranslation('accountNav');
  const { user } = useAuth();
  const isAdmin = user?.is_admin ?? false;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
      <nav className="mb-6 flex flex-wrap items-center gap-2 no-underline-links">
        <NavLink to="/account/profile" className={({ isActive }) => tabClasses(isActive)}>
          {t('tabs.profile')}
        </NavLink>
        {!isAdmin && (
          <NavLink to="/account/orders" className={({ isActive }) => tabClasses(isActive)}>
            {t('tabs.orders')}
          </NavLink>
        )}
        {!isAdmin && (
          <NavLink to="/account/company" className={({ isActive }) => tabClasses(isActive)}>
            {t('tabs.company')}
          </NavLink>
        )}
        <NavLink to="/account/settings" className={({ isActive }) => tabClasses(isActive)}>
          {t('tabs.settings')}
        </NavLink>
      </nav>

      {/* --- START EDIT: Center account tab content globally --- */}
      <div className="mx-auto max-w-6xl">
        <Outlet />
      </div>
      {/* --- END EDIT: Center account tab content globally --- */}
    </div>
  );
}
// --- END PATCH: AccountLayout with horizontal tabs and Outlet ---